import { z } from "zod";

export const PasswordLoginSchema = z.object({
	email: z
		.string({ required_error: "Bitte gib eine E-Mail Adresse ein." })
		.email("Bitte gib eine gültige E-Mail Adresse ein."),
	password: z
		.string({ required_error: "Bitte gib ein Passwort ein." })
		.min(8, "Das Passwort muss mindestens 8 Zeichen lang sein."),
});
